import { FC } from "react";
import Typography from "@/components/Typography";
import MobilePopup from "@/components/MobilePopup";
import styles from "./CreatePostMobileDialog.module.scss";

type Props = {
  onClose: () => void;
  onLeave: () => void;
};

const CreatePostMobileDialogCloseConfirmation: FC<Props> = ({
  onClose,
  onLeave,
}) => {
  const actions = [
    {
      onClick: onLeave,
      type: "info",
      label: "Leave page",
    },
  ];

  return (
    <MobilePopup onClose={onClose} actions={actions}>
      <div className={styles.closeDialogRoot}>
        <Typography variant="h6" className={styles.closeDialogTitle}>
          Leave without posting?
        </Typography>
        <Typography variant="body1">
          Any changes you&apos;ve made will be lost if you close it.
        </Typography>
      </div>
    </MobilePopup>
  );
};

export default CreatePostMobileDialogCloseConfirmation;
